import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const modalDefaultVariants = {
  "size": "md",
  "isCentered": true,
  "scrollBehavior": "inside"
}
const modalCompoundVariants = [
  {
    "scrollBehavior": "inside",
    "isFull": true,
    "css": {
      "root": {
        "height": "100%",
        "maxHeight": {
          "base": "calc(100% - 48px)",
          "smDown": "calc(100% - 16px)",
          "mdDown": "calc(100% - 32px)",
          "lgDown": "calc(100% - 48px)"
        },
        "maxWidth": {
          "base": "calc(100% - 48px)",
          "smDown": "calc(100% - 16px)",
          "mdDown": "calc(100% - 32px)",
          "lgDown": "calc(100% - 48px)"
        }
      }
    }
  },
  {
    "scrollBehavior": "inside",
    "isFull": false,
    "css": {
      "root": {
        "maxHeight": {
          "base": "90vh",
          "xsDown": "calc(100% - 16px)",
          "smDown": "calc(100% - 32px)",
          "mdDown": "calc(100% - 48px)",
          "lgDown": "90vh"
        }
      }
    }
  },
  {
    "scrollBehavior": "outside",
    "isFull": true,
    "css": {
      "root": {
        "minHeight": {
          "base": "calc(100% - 48px)",
          "smDown": "calc(100% - 16px)",
          "mdDown": "calc(100% - 32px)",
          "lgDown": "calc(100% - 48px)"
        },
        "maxWidth": {
          "base": "calc(100% - 48px)",
          "smDown": "calc(100% - 16px)",
          "mdDown": "calc(100% - 32px)",
          "lgDown": "calc(100% - 48px)"
        }
      }
    }
  },
  {
    "scrollBehavior": "outside",
    "isFull": false,
    "css": {
      "root": {}
    }
  }
]

const modalSlotNames = [
  [
    "root",
    "Modal__root"
  ],
  [
    "wrapper",
    "Modal__wrapper"
  ],
  [
    "title",
    "Modal__title"
  ],
  [
    "header",
    "Modal__header"
  ],
  [
    "back",
    "Modal__back"
  ],
  [
    "close",
    "Modal__close"
  ],
  [
    "content",
    "Modal__content"
  ],
  [
    "section",
    "Modal__section"
  ],
  [
    "footer",
    "Modal__footer"
  ]
]
const modalSlotFns = /* @__PURE__ */ modalSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, modalDefaultVariants, getSlotCompoundVariant(modalCompoundVariants, slotName))])

const modalFn = memo((props = {}) => {
  return Object.fromEntries(modalSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const modalVariantKeys = [
  "isCentered",
  "scrollBehavior",
  "size",
  "isFull"
]
const getVariantProps = (variants) => ({ ...modalDefaultVariants, ...compact(variants) })

export const modal = /* @__PURE__ */ Object.assign(modalFn, {
  __recipe__: false,
  __name__: 'modal',
  raw: (props) => props,
  variantKeys: modalVariantKeys,
  variantMap: {
  "isCentered": [
    "true",
    "false"
  ],
  "scrollBehavior": [
    "inside",
    "outside"
  ],
  "size": [
    "sm",
    "md",
    "lg",
    "full"
  ],
  "isFull": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, modalVariantKeys)
  },
  getVariantProps
})